import AddModal from './AddModal';

export { AddModal };
export default AddModal;
